import React from 'react';
// import sal from "sal.js";
// import { ToastContainer } from "react-toastify";
import { ServiceProvider } from './src/context/LoaderContext';
// import PageTransition from "./src/components/PageTransition";

import 'sal.js/dist/sal.css';
import "./src/styles/global.css"
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// export const onClientEntry = () => {
//     sal()
// }

export const wrapRootElement = ({ element }) => (
    <ServiceProvider>
        {element}
        {/* <ToastContainer /> */}
        {/* <PageTransition>{element}</PageTransition> */}
    </ServiceProvider>
);